import { Dialog, DialogTitle } from "@mui/material";
import { ReactElement } from "react";

import { TagDetail } from "~frontend/graphql/tags";

import EditTagForm from "./EditTagForm";
import {
  EditTagFormType,
  NgpVanIntegration,
  tagIntegrationsToFormValues,
} from "./types";

export default function EditTagDialog({
  open,
  onClose,
  onSave,
  vanIntegrations,
  tag,
  allTagNames,
}: {
  open: boolean;
  onClose: () => void;
  onSave: (formData: EditTagFormType) => Promise<void>;
  vanIntegrations: NgpVanIntegration[];
  tag: TagDetail;
  allTagNames: string[];
}): ReactElement {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Tag</DialogTitle>
      <EditTagForm
        initialName={tag.name}
        initialIntegrations={tagIntegrationsToFormValues(
          tag.integrationActions
        )}
        onSave={onSave}
        onCancelClick={onClose}
        vanIntegrations={vanIntegrations}
        allOtherTagNames={allTagNames.filter(name => name !== tag.name)}
      />
    </Dialog>
  );
}
